// @flow

import * as React from 'react'
import { Label, Segment, Header, Message } from 'semantic-ui-react'
import { DataGrid, DataGridDuck } from 'react-redux-components'
import { connect, type Connector } from 'react-redux'

import authenticatedRequest from '../store/authenticated-request'
import CampaignsDropdown from '../systemwide/allowed-campaigns-dropdown'
import Modal from '../systemwide/modal'
import PanelToolbar from './panel-toolbar'
import PanelForm from './panel-form'
import { cancelEdit, updateDoctor, deleteDoctorCancel, deleteDoctor, type Doctor } from '../store/manage-panel'
import { isViewer, isAdmin } from '../store/authentication'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  currentRecord: Doctor | false,
  currentCampaign: string,
  campaignFromRoute: boolean,
  formPristine: boolean,
  selectedRecords: Array<Object>,
  isViewer: boolean,
  isAdmin: boolean,
  deleteDoctorPending: Doctor | false,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let hasSelection = state.panel.grid.selectedRecords.length > 0
  return {
    currentRecord: hasSelection ? state.panel.grid.selectedRecords[0] : false,
    currentCampaign: state.allowedCampaigns.currentCampaign,
    campaignFromRoute: 'campaignName' in state.location.payload,
    formPristine: state.panel.form.$form.pristine,
    selectedRecords: state.panel.grid.selectedRecords,
    isViewer: isViewer(state),
    isAdmin: isAdmin(state),
    deleteDoctorPending: state.panel.status.deleteDoctorPending,
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps

class PanelPage extends React.Component<Props> {
  static defaultProps = {}

  cancelEdit = () => {
    this.props.dispatch(cancelEdit())
  }

  commitEdit = (doctor: Doctor) => {
    this.props.dispatch(updateDoctor(this.props.currentCampaign, doctor))
  }

  deleteDoctorCancel = () => {
    this.props.dispatch(deleteDoctorCancel())
  }

  deleteDoctor = () => {
    if (this.props.currentRecord) {
      this.props.dispatch(deleteDoctor(this.props.currentCampaign, this.props.currentRecord))
    }
  }

  render() {
    let toBeDeleted = {
      _id: typeof this.props.deleteDoctorPending !== 'boolean' ? this.props.deleteDoctorPending._id : '',
      nominativo:
        typeof this.props.deleteDoctorPending !== 'boolean'
          ? this.props.deleteDoctorPending.nome + ' ' + this.props.deleteDoctorPending.cognome
          : '',
    }
    let verb = this.props.isAdmin ? 'Gestione' : 'Visualizzazione'

    return (
      <div style={{ height: '100vh', paddingTop: '9ex' }}>
        <Modal
          open={typeof this.props.deleteDoctorPending !== 'boolean'}
          header={<Header icon="delete" content="Conferma eliminazione medico" />}
          content={
            <span>
              {`Eliminare il medico ${toBeDeleted.nominativo} con ID: ${toBeDeleted._id} ?`}
              <br />Questa operazione è irreversibile e comporta l'eliminazione di tutte le visite associate.
            </span>
          }
          onCancel={this.deleteDoctorCancel}
          onConfirm={this.deleteDoctor}
        />
        {this.props.currentCampaign === '' && (
          <Message
            style={{
              marginTop: '40vh',
              marginLeft: '33vw',
              position: 'absolute',
              zIndex: '1000',
              width: '33vw',
              textAlign: 'center',
            }}
            floating
            info>
            <Message.Header>Gestisci Panel</Message.Header>
            <p>Selezionare una campagna dal menù a tendina in alto a destra</p>
          </Message>
        )}
        <Segment
          padded={false}
          secondary
          style={{ margin: '0 3ex 0 3ex', height: '90vh', display: 'flex', flexDirection: 'column' }}>
          <Label attached="top" color="blue" size="small" style={{ zIndex: '700', width: '100%' }}>
            <div style={{ fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>{`${verb} Panel`}</div>
            {this.props.campaignFromRoute && (
              <div style={{ float: 'right', height: '2rem' }}>
                <span style={{ marginRight: '1ex', fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>
                  {this.props.currentCampaign}
                </span>
              </div>
            )}
            {!this.props.campaignFromRoute && (
              <div style={{ float: 'right' }}>
                <span style={{ marginRight: '1ex', fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>
                  Seleziona campagna:
                </span>
                <CampaignsDropdown
                  onChangeAction={DataGridDuck.creators.resetDatagrid('panelGrid')}
                  style={{ minWidth: '40ex' }}
                />
              </div>
            )}
          </Label>
          <DataGrid
            disabled={true}
            fetchOnMount={false}
            model="panelGrid"
            request={authenticatedRequest}
            dataUrl={this.props.currentCampaign !== '' ? '/api/panels/' + this.props.currentCampaign + '/doctors' : ''}
            initialPageSize={40}
            toolbarContent={<PanelToolbar />}
            sidebarContent={
              this.props.currentRecord && (
                <PanelForm
                  loadedRecord={Object.keys(this.props.currentRecord)}
                  pristine={this.props.formPristine}
                  onCancel={this.cancelEdit}
                  onSubmit={this.commitEdit}
                />
              )
            }
          />
        </Segment>
      </div>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(PanelPage)



// WEBPACK FOOTER //
// ./src/panels/manage-panel.js